import React from 'react'
import { CampaignListItem } from '../components/CampaignListItem'
import {getPercentage} from '../utils/utils';
import { RequestListItem } from './RequestListItem';

export const RequestCampaignList = ({ item, index, authState }) => {

    if (item !== null && item !== undefined) {
        if (item.type === 'assignment') {
            return <RequestListItem key={index}
                item={item}
                authState={authState}
            />
        }
        return <CampaignListItem key={index}
            responsesSubmitted={item.noSubmitted + " / " + item.noAssignments + " (" + getPercentage(item.noAssignments, item.noSubmitted) + "%)  "}
            accessToken={authState.accessToken.accessToken}
            campaign={item}
        />
    }

    return <></>
}